






































































































































import {
    Component,
    Prop,
    Vue,
    Watch
} from 'vue-property-decorator';
import RevisionList from '@/views/shortCredit/RevisionList.vue';
import moment from 'moment';

@Component({
    components: {
        RevisionList
    }
})
export default class CreditDetails extends Vue {
    @Prop({
        default: false
    })
    public isShow!: boolean;
    @Prop({
        default: {}
    })
    public currentEntity!: any;
    @Prop({
        default: {}
    })
    public creditSetting!: any;
    public loading: any = {
        rejected: false,
        accepted: false
    }
    public isActiveRevision: boolean = false;

    public roles: any = this.$store.getters['Auth/roles'];
    public currectUser: any = this.$store.getters['Auth/getCurrentUser'];
    get checkViewButton() {
        return (Array.isArray(this.roles) && this.roles.some((role: any) => role.id === this.currentEntity.next_role_id)) || this.currectUser.id === 1;
    }
    capitalize(string: string) {
        if (typeof string !== 'string') return '';
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    pickerOptions(date: any) {
        const maxDays = this.creditSetting.max_credit_period;
        const isPolicyStrict = this.creditSetting.policy_strict;
        return {
            disabledDate(time: any) {
                if (isPolicyStrict) {
                    return time.getTime() < moment(date) || time.getTime() > moment(date).add(maxDays, 'days');
                }
                return time.getTime() < moment(date);
            }
        }
    }

    checkStatus(status: string) {
        return status == 'pending' || status == 'accepted';
    }

    toggleDatePicker() {
        (this.$refs.datePicker as any).showPicker();
    }

    updateDate(date: string) {
        this.currentEntity.payment_date = date;
    }

    dateFormatator(format: string, date: string) {
        return moment(date).format(format);
    }

    calculateDayCount(date: string, diffDate: string) {
        const startDate = moment(diffDate).startOf('day');
        const endDate = moment(date).startOf('day');
        return endDate.diff(startDate, 'days');
    }

    checkAttachment(checklist: any) {
        return this.currentEntity.check_lists.some((item: any) => item.name === checklist.name);
    }

    getCheckListAttachment(checklist: any) {
        const attachment = this.currentEntity.check_lists.find((item: any) => item.name === checklist.name);
        if (process.env.NODE_ENV == 'development' && process.env.VUE_APP_ASSET_URL) {
            return `${process.env.VUE_APP_ASSET_URL.toString().replace(':8080', '')}/${attachment.attachment}`;
        }
        return attachment.attachment;
    }

    submitBulkAction(action: string) {
        const data = {
            payment_date: this.currentEntity.payment_date,
            approved_amount: this.currentEntity.approved_amount,
            target_achievement: this.currentEntity.target_achievement,
            deposit_commission: this.currentEntity.deposit_commission,
            remarks: this.currentEntity.remarks,
            status: action
        };
        this.loading[action] = true;
        this.$http.patch(this.$api('/department-credits/' + this.currentEntity._id), data).then((response: any) => {
            this.$emit('update:isShow', false);
            this.$emit('updateed', response.data.credit);
            this.$notify({
                title: 'Success',
                message: 'Successfully ' + action,
                type: 'success'
            });
        }).catch((error: any) => {
            window.console.log(error);
            (
                this.$refs.formValidator as Vue & {
                    setErrors: (errors: []) => any;
                }
            ).setErrors(error.response.data.errors);
        }).finally(() => {
            this.loading[action] = false;
        });
    }

    getLastCreditInfo(field: string) {
        if (this.currentEntity.last_credit_info) {
            if (field == 'paid_at') {
                return this.currentEntity.last_credit_info[field] ?? this.currentEntity.last_credit_info['payment_status'];
            }
            return this.currentEntity.last_credit_info[field];
        }
        return '-';
    }
}
